import { Component, Input, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-warning-dialog',
  templateUrl: './warning-dialog.component.html',
  styleUrls: ['./warning-dialog.component.scss']
})
export class WarningDialogComponent {


  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  @Output() btnOkPressed: EventEmitter<boolean> = new EventEmitter();
  @Output() btnCancelPressed: EventEmitter<boolean> = new EventEmitter();

  constructor(
    public dialogRef: MatDialogRef<WarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  pressButtonOk() {
    this.btnOkPressed.emit();
    this.dialogRef.close();
  }

  pressButtonCancel() {
    this.btnCancelPressed.emit();
  }

}
